import { render } from "./leave-types.vue?vue&type=template&id=795293a1&scoped=true"
import script from "./leave-types.vue?vue&type=script&lang=js"
export * from "./leave-types.vue?vue&type=script&lang=js"

import "./leave-types.vue?vue&type=style&index=0&id=795293a1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795293a1"]])

export default __exports__